  import axios from 'axios';
  import { BASE_URL, XC_TOKEN, TABLES } from './apiConstants';

  const chatsApi = {
    getAll: async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        if (!user || !user.Email) {
          throw new Error('User email not found in localStorage.');
        }

        const response = await axios.get(
          `${BASE_URL}/tables/${TABLES.CHATS}/records`,
          {
            headers: { 'xc-token': XC_TOKEN },
            params: {
              where: `(Users,eq,${user.Email})`,
              fields: ['recId', 'Name', 'Desc', 'KnowledgeBases', 'CreatedAt', 'UpdatedAt'],
            },
          }
        );

        return response.data.list.map((chat) => ({
          id: chat.recId,
          name: chat.Name,
          description: chat.Desc,
          knowledgeBaseId: chat.KnowledgeBases?.[0]?.recId || null,
          createdAt: chat.CreatedAt,
          updatedAt: chat.UpdatedAt,
        }));
      } catch (error) {
        console.error('Error fetching chats:', {
          message: error.message,
          response: error.response?.data,
          config: error.config,
        });
        throw error;
      }
    },

    get: async (chatId) => {
      try {
        const response = await axios.get(
          `${BASE_URL}/tables/${TABLES.CHATS}/records/${chatId}`,
          { headers: { 'xc-token': XC_TOKEN } }
        );
        const chatData = response.data;
        return {
          id: chatData.recId,
          name: chatData.Name,
          description: chatData.Desc,
          knowledgeBaseId: chatData.KnowledgeBases?.[0]?.recId || null,
          createdAt: chatData.CreatedAt,
          updatedAt: chatData.UpdatedAt,
        };
      } catch (error) {
        console.error('Error fetching chat:', error);
        throw error;
      }
    },

    create: async (chatData) => {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        if (!user || !user.recId) {
          throw new Error('User recId not found in localStorage.');
        }

        const payload = {
          Name: chatData.name,
          Desc: chatData.description,
          Users: [user.recId],
          KnowledgeBases: chatData.knowledgeBaseId
            ? [chatData.knowledgeBaseId]
            : [],
        };

        const response = await axios.post(
          `${BASE_URL}/tables/${TABLES.CHATS}/records`,
          payload,
          {
            headers: {
              'xc-token': XC_TOKEN,
              'Content-Type': 'application/json',
            },
          }
        );

        return {
          id: response.data.recId,
          name: response.data.Name,
          description: response.data.Desc,
          knowledgeBaseId: response.data.KnowledgeBases?.[0]?.recId || null,
          createdAt: response.data.CreatedAt,
          updatedAt: response.data.UpdatedAt,
        };
      } catch (error) {
        console.error('Detailed creation error:', {
          message: error.message,
          response: error.response?.data,
          request: {
            url: error.config?.url,
            method: error.config?.method,
            data: error.config?.data,
          },
        });
        
        const errorMessage = error.response?.data?.msg || 
                          error.response?.data?.message ||
                          error.message ||
                          'Failed to create chat';
        
        throw new Error(errorMessage);
      }
    },

    update: async (chatId, updateData) => {
      try {
        const payload = {};
        if (updateData.knowledgeBaseId !== undefined) {
          payload.KnowledgeBases = updateData.knowledgeBaseId 
            ? [updateData.knowledgeBaseId] 
            : [];
        }

        const response = await axios.patch(
          `${BASE_URL}/tables/${TABLES.CHATS}/records/${chatId}`,
          payload,
          {
            headers: {
              'xc-token': XC_TOKEN,
              'Content-Type': 'application/json',
            },
          }
        );

        return {
          id: response.data.recId,
          name: response.data.Name,
          description: response.data.Desc,
          knowledgeBaseId: response.data.KnowledgeBases?.[0]?.recId || null,
          createdAt: response.data.CreatedAt,
          updatedAt: response.data.UpdatedAt,
        };
      } catch (error) {
        console.error('Error updating chat:', error);
        throw error;
      }
    },

    delete: async (chatId) => {
      try {
        await axios.delete(`${BASE_URL}/tables/${TABLES.CHATS}/records/${chatId}`, {
          headers: { 'xc-token': XC_TOKEN },
        });
        return true;
      } catch (error) {
        console.error('Error deleting chat:', error);
        throw error;
      }
    },
  };

  export default chatsApi;